import { styled } from '@mui/material';
import { Swiper } from 'swiper/react';

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
`;
